module.exports = __webpack_public_path__ + "static/media/W00F0001.81fdc1d5.svg";